import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, authHeaders, getToken } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Shared report dialog for both a store and a specific offer.
export default function ReportDialog({ open, onOpenChange, vendorId, offerId, title }) {
  const [reasons, setReasons] = useState([]);
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) api.get("/report-reasons").then((r) => setReasons(r.data.reasons || r.data || [])).catch(() => {});
  }, [open]);

  const submit = async () => {
    if (!reason) { toast.error("Scegli un motivo"); return; }
    setSending(true);
    try {
      const body = { vendor_id: vendorId, reason, note };
      if (offerId) body.offer_id = offerId;
      await api.post("/reports", body, { headers: getToken("client") ? authHeaders("client") : {} });
      toast.success("Segnalazione inviata. Grazie!");
      onOpenChange(false);
      setReason(""); setNote("");
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
    finally { setSending(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-3xl" data-testid="report-dialog">
        <DialogHeader><DialogTitle className="text-xl font-extrabold">{title || "Segnala un problema"}</DialogTitle></DialogHeader>
        <DialogDescription className="sr-only">Scegli un motivo per la segnalazione e aggiungi eventuali dettagli.</DialogDescription>
        <div className="space-y-3">
          <div className="space-y-2">
            {(reasons.length ? reasons : [{ id: "altro", label: "Altro" }]).map((r) => {
              const rid = r.id || r.key; const rlabel = r.label || rid;
              return (
                <button key={rid} onClick={() => setReason(rid)} data-testid={`reason-${rid}`}
                  className={`w-full text-left p-3 rounded-xl border font-semibold text-sm transition-colors ${reason === rid ? "border-[#E63946] bg-[#FFF1F2] text-[#BE123C]" : "border-slate-200 text-slate-600"}`}>
                  {rlabel}
                </button>
              );
            })}
          </div>
          <Textarea value={note} onChange={(e) => setNote(e.target.value)} rows={3} placeholder="Aggiungi dettagli (opzionale)" className="rounded-xl" data-testid="report-note" />
          <Button onClick={submit} disabled={sending} data-testid="report-submit" className="w-full h-12 rounded-xl font-bold">
            {sending ? <Loader2 className="h-5 w-5 animate-spin" /> : "Invia segnalazione"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
